import React from 'react'
import PropTypes from 'prop-types'
import InvoiceCorrectionForm from './InvoiceCorrectionForm'
import InvoiceCorrectionResult from './InvoiceCorrectionResult'
import currentUserHasAccess from '../../../../util/widget-helper'
import { INVOICE_CORRECTION_WIDGET } from '../../../process/ui-definition/process-ui'


const InvoiceCorrection = (props) => {
    if (!currentUserHasAccess(INVOICE_CORRECTION_WIDGET)) {
        return null
    }

    const { invoice, invoiceCorrection } = props
    if (!invoice) {
        return null
    }
    return invoiceCorrection ? <InvoiceCorrectionResult {...props}/> : <InvoiceCorrectionForm {...props}/>
}

InvoiceCorrection.propTypes = {
    invoice: PropTypes.object,
    invoiceCorrection: PropTypes.object,
    invoiceCorrectionData: PropTypes.object.isRequired,
    confirmationModalOpen: PropTypes.bool.isRequired,
    changeInvoiceCorrectionItem: PropTypes.func.isRequired,
    showConfirmationModal: PropTypes.func.isRequired,
    closeConfirmationModal: PropTypes.func.isRequired,
    createInvoiceCorrection: PropTypes.func.isRequired,
    changeInvoiceCorrectionData: PropTypes.func.isRequired,
}


export default InvoiceCorrection




// WEBPACK FOOTER //
// ./src/modules/invoice/component/correction/InvoiceCorrection.js